import { Card } from "@shadcn-in-nx/ui/card";
import { Headphones, Video, Zap } from "lucide-react";
import { useTranslation } from "react-i18next";

export function HandsOnSupportInfo() {
    const { t } = useTranslation();

    return (
        <Card className="p-6 border-2 border-border/50 bg-muted/30">
            <h3 className="text-lg font-semibold mb-3 flex items-center gap-2">
                <Headphones className="w-5 h-5" />
                {t("billing.supportPlans.title")}
            </h3>
            <p className="text-muted-foreground mb-4">
                {t("billing.supportPlans.description")}
            </p>
            <div className="grid sm:grid-cols-2 gap-4">
                <div className="flex items-start gap-3">
                    <Video className="w-5 h-5 text-blue-500 mt-0.5" />
                    <div>
                        <p className="font-medium text-sm">{t("billing.supportPlans.screenSharing")}</p>
                        <p className="text-xs text-muted-foreground">{t("billing.supportPlans.screenSharingDesc")}</p>
                    </div>
                </div>
                <div className="flex items-start gap-3">
                    <Zap className="w-5 h-5 text-yellow-500 mt-0.5" />
                    <div>
                        <p className="font-medium text-sm">{t("billing.supportPlans.priorityResponse")}</p>
                        <p className="text-xs text-muted-foreground">{t("billing.supportPlans.priorityResponseDesc")}</p>
                    </div>
                </div>
            </div>
        </Card>
    );
}
